// node_modules
import { FC, useContext, MouseEvent } from "react";
// styles
import styles from "./topbarMenu.module.scss";
// Components
import { TopbarMenuItem } from "./TopbarMenuItem";
import { LetteredUserCircle } from "Components";
import { TechnologySearchBar } from "./TechnologySearchBar";
// Images
import FindestLogoWhite from "Images/findest_logo_white.png";
// Contexts
import { AuthContext } from "Stores";
// Helpers
import { AxiosHelperSingleton } from "Helpers";
// Controllers
import { UserControllerSingleton } from "Controllers";
// Constants
import { FeatureToggleConstants } from "Constants";

export const TopbarMenu: FC = () => {
    const { authState } = useContext(AuthContext);

    const topbarMenuNavigationItemData = [
        {
            href: "/AccountDashboard/Index",
            text: "Cases"
        },
        {
            href: "/Idea/Index",
            text: "Ideas"
        },
        {
            href: "/Account",
            text: "Users"
        }
    ];
    
    const logoutAsync = async (event: MouseEvent<HTMLAnchorElement>): Promise<void> => {
        event.preventDefault();
        await UserControllerSingleton.logoutAsync();
        window.location.replace(`${AxiosHelperSingleton.getServerBaseURL()}Account/Login`);
    };

    return (
        <header className={styles.topbarMenu}>
            <div className={styles.topbarMenuLogoContainer}>
                <a className={styles.topbarMenuLink} href="/AccountDashboard/Index">
                    <img className={styles.topbarMenuLogo} src={FindestLogoWhite} alt="Findest Logo" />
                </a>
            </div>
            {topbarMenuNavigationItemData.map((topbarMenuNavigationItemData, index) => {
                return <TopbarMenuItem
                        key={index}
                        href={topbarMenuNavigationItemData.href} 
                        text={topbarMenuNavigationItemData.text}
                        anchorOnClickAsync={undefined} />;
            })}
            {FeatureToggleConstants.SearchTechnologyThroughCases ?
                    <TechnologySearchBar />
                :
                    null
            }
            <div className={styles.topbarMenuAccountAndLogoutContainer}>
                <LetteredUserCircle username={authState.userEmail} link="/Account/Manage" />
                <TopbarMenuItem
                            href="/Account/Logout" 
                            text="Logout"
                            anchorOnClickAsync={logoutAsync} />
            </div>
        </header>
    );
};
